import {
	ADD_FORM_DATA,
	ADD_SOCIAL_FORM_DATA,
	INIT_FORM,
	INIT_SOCIAL_FORM,
	RESET_FORM_DATA,
} from '../constants/ActionTypes';

export const initForm = payload => ({ type: INIT_FORM, payload });
export const resetForm = payload => ({
	type: RESET_FORM_DATA,
	payload,
});
export const initMediaForm = payload => ({ type: INIT_SOCIAL_FORM, payload });

export const addFormData = payload => ({ type: ADD_FORM_DATA, payload });
export const addMediaForm = payload => ({
	type: ADD_SOCIAL_FORM_DATA,
	payload,
});
